import { useStyle } from '@/classify';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import Radio from '../../RadioGroup/radio';
import defaultClasses from './filterItemRadio.module.css';

const FilterItemRadio = props => {
  const { filterApi, group, item, onApply = null, labels } = props;
  const { removeGroup, toggleItem } = filterApi;
  const { title, value } = item;
  const classes = useStyle(defaultClasses);
  const { formatMessage } = useIntl();

  const label = item.label ? item.label : item.title;

  const ariaLabel = formatMessage(
    {
      id: 'filterModal.item.applyFilter',
      defaultMessage: 'Apply filter "{optionName}".',
    },
    {
      optionName: label,
    },
  );

  const handleOnchange = useCallback(
    e => {
      removeGroup({
        group,
      });
      console.log('filterItemRadio handleOnchange', e.target);

      if (e.target.value === item.value) {
        toggleItem({
          group,
          item,
        });
      }

      if (typeof onApply === 'function') {
        onApply(group, item);
      }
    },
    [group, item, onApply, removeGroup, toggleItem],
  );

  const element = (
    <Radio
      classes={classes}
      id={`item-${group}-${value}`}
      label={title}
      value={value}
      onChange={handleOnchange}
      ariaLabel={ariaLabel}
    />
  );

  labels.set(element, label);

  return element;
};

export default FilterItemRadio;
